module.exports = __webpack_public_path__ + "media/images/athletes/2131-d7abff5cb7d945da307111374d257c6b.png";